export default __webpack_public_path__ + "static/media/person.d24db0b4.svg";